import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AdminSessionContainer from './SessionList';
import {Link} from 'react-router-dom';
import * as firebase from 'firebase';

//gets user props from app.js


/**
 * This component is the admin homepage and renders the admin session
 * simulationContainer as well as quick start, custom session, and manage admin buttons
 */
class AdminHome extends Component {
    constructor(props) {
        //console.log("AdminHome created");
        super(props);
        this.state = {
            stepsEnabled: false,
            initialStep: 0,
            steps: [
                {
                    element: '.network',
                    intro: 'This button creates a networked session',
                },
                {
                    element: '.solitare',
                    intro: 'This button creates a solo session',
                },
                {
                    element: '.title',
                    intro: 'This is a sessions title'
                },
                {
                    element: '.join',
                    intro: 'You can join a session here(if its not solo)'
                },
                {
                    element: '.rank',
                    intro: 'Here you can see a live feed of how players are doing'
                },
                {
                    element: '.edit',
                    intro: 'Here you can edit the title of a session you created'
                },
                {
                    element: '.delete',
                    intro: 'Here you can delete a session you created'
                },
                {
                    element: '.solo',
                    intro: 'Here is where you can toggle whether a session you created is solo or networked'
                },
            ]
        };
        this.networkSession = this.networkSession.bind(this);
        this.soloSession = this.soloSession.bind(this)
    }


    //this function generates a quick session with default parameters
    networkSession() {
        console.log("AdminHome networkSession");
        //TODO: change these for a network session
        const sessionRef = firebase.database().ref().child(this.props.institution).child("Sessions");
        const newSessionRef = sessionRef.push();
        const timeCreated = new Date().toUTCString();
        const session = {
            //"Title": this.props.user.displayName + timeCreated,
            "UserCount": 0,
            "GameParams": {
                "StartPrice": "2100", //(this.state.StartPrice*100).toFixed(0),
                "msPerSec": 20,
                "numLiq": 150,
                "numInf": 100,
                "numMom": 100,
                "numPStar": 3,
                "FracOfDay": 1
            },
            "StartSim": {
                "SessionID": newSessionRef.key
            },
            "Info": {
                "Title": this.props.user.displayName + " " + timeCreated,
                "Creator": this.props.user.uid,
                "Solo": false
            }
        };
        newSessionRef.set(session);
        /*newSessionRef.child("Info").set(
            {
                "Title": this.props.user.displayName + " " + timeCreated,
                "Creator": this.props.user.uid,
                "Solo": false
            })*/
        // console.log("called");
        // let adminRef = firebase.database().ref().child("Admin");
        // let newadminRef = adminRef.push();
        // console.log(newadminRef);
        // let admin = {
        //   "name": "jorss"
        // };
        // console.log(admin);
        // newadminRef.set(admin);
    }

    soloSession() {
        console.log("AdminHome soloSession");
        const sessionRef = firebase.database().ref().child(this.props.institution).child("Sessions");
        const newSessionRef = sessionRef.push();
        const timeCreated = new Date().toUTCString();
        const session = {
            //"Title": this.props.user.displayName + timeCreated,
            "UserCount": 15,
            "GameParams": {
                "StartPrice": "2100", //(this.state.StartPrice*100).toFixed(0),
                "msPerSec": 20,
                "numLiq": 200,
                "numInf": 100,
                "numMom": 100,
                "numPStar": 4,
                "FracOfDay": 1
            },
            "StartSim": {
                "SessionID": newSessionRef.key
            },
            "Info": {
                "Title": this.props.user.displayName + " " + timeCreated,
                "Creator": this.props.user.uid,
                "Solo": true
            }
        };
        newSessionRef.set(session);

        // console.log("called");
        // let adminRef = firebase.database().ref().child("Admin");
        // let newadminRef = adminRef.push();
        // console.log(newadminRef);
        // let admin = {
        //   "name": "jorss"
        // };
        // console.log(admin);
        // newadminRef.set(admin);
    }

    componentDidMount() {
        //  console.log("AdminHome componentDidMount");

    }

    startIntro() {
        //console.log("AdminHome startIntro");
        this.setState({
            stepsEnabled: true
        })
    }

    render() {
        // console.log("AdminHome render");

        const {stepsEnabled, steps, initialStep} = this.state;

        return (
            <div>
                <div className="admin-menu">
                    <Link to="/Home">
                        <button onClick={this.networkSession}>
                            Network Session
                        </button>
                    </Link>
                    <Link to="/Home">
                        <button onClick={this.soloSession}>
                            Solitaire Session
                        </button>
                    </Link>
                    <Link target="_self" to="https://firebasestorage.googleapis.com/v0/b/trxacg.appspot.com/o/standAloneStockTrakDyn.jsp?alt=media&token=b6624a33-3a5f-48e2-a77e-f67879785005">
                    <button>
                        Old Java Version
                    </button>
                    </Link>
                    {/*<Link to="/CreateSession">*/}
                    {/*<button>*/}
                    {/*Custom Session*/}
                    {/*</button>*/}
                    {/*</Link>*/}
                    {/*<Link to="/Tutorial">*/}
                    {/*<button>*/}
                    {/*Simulation Tutorial*/}
                    {/*</button>*/}
                    {/*</Link>*/}
                    {/*<Link to="/ManageAdmin">*/}
                    {/*<button>*/}
                    {/*Manage Admins*/}
                    {/*</button>*/}
                    {/*</Link>*/}
                </div>
                <AdminSessionContainer
                    user={this.props.user}
                    institution={this.props.institution}/>
            </div>
        );
    }
}

AdminHome.propTypes = {
    user: PropTypes.object,
    authed: PropTypes.bool
};

export default AdminHome;



// WEBPACK FOOTER //
// ./src/components/Dashboard/MainDashboard.js